/* eslint-disable class-methods-use-this */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Query } from 'react-apollo';
import Login from './Login';
import { isAuthenticated } from '../services/auth/authenticator';
import { ACCOUNT_LIST } from '../components/Query';
import { Loading } from '../components/Loading';
import PublicIndex from './PublicIndex';
import Index from './Index';

const IndexWrapper = () => {
  const location = useLocation();

  const authenticated = isAuthenticated();

  if (
    location.pathname.includes('account-invitation') ||
    location.pathname.includes('user-invitation') ||
    location.pathname.includes('register') ||
    location.pathname.includes('register-confirmation') ||
    location.pathname.includes('email-verification') ||
    location.pathname.includes('forgot-password') ||
    location.pathname.includes('reset-password') ||
    location.pathname.includes('multi-factor-confirmation') ||
    location.pathname.includes('buy-own-subscription')
  ) {
    return <PublicIndex />;
  }

  if (!authenticated) {
    return <Login />;
  }

  return (
    <Query query={ACCOUNT_LIST} variables={{ first: 100 }}>
      {({ loading, data, error }) => {
        if (error) {
          return `Error: ${error}`;
        }

        if (loading) {
          return <Loading />;
        }

        const { accounts } = data.viewer;
        const { edges } = accounts;

        return <Index edges={edges} />;
      }}
    </Query>
  );
};

export default IndexWrapper;
